import { render, staticRenderFns } from "./manual-settlement.vue?vue&type=template&id=ef18a45a&"
import script from "./manual-settlement.vue?vue&type=script&lang=js&"
export * from "./manual-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports